'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { Container, SliderContainer } from './Slider.css.js';
import Slides from './Slides/index.js';
import Pagination from '../Slider/Pagination/index.js';
import { fixedNumber } from '../Utils/helpers.js';
import { useDidUpdateEffect } from '../Utils/hooks.js';

var Slider = function (props) {
    var slidesProps = props.slides, id = props.id, paginationProps = props.pagination, containerProps = props.container, autoEnable = props.autoEnable, _a = props.autoTime, autoTime = _a === void 0 ? 4000 : _a, loadingEnable = props.loadingEnable, loadingHeight = props.loadingHeight, _b = props.transitionTime, transitionTime = _b === void 0 ? 250 : _b, _c = props.transitionSensitivity, transitionSensitivity = _c === void 0 ? 0.15 : _c, _d = props.isRobot, isRobot = _d === void 0 ? false : _d, _e = props.className, className = _e === void 0 ? '' : _e, children = props.children;
    // init value props
    var slides = __assign({ spaceBetween: 8, elementPerView: 1 }, slidesProps);
    var pagination = __assign({ elementPerPage: 1, type: 'default', position: 'default', extraPage: 2, defaultPage: 0 }, paginationProps);
    var container = __assign({}, containerProps);
    var _f = useState(null), sliderContainer = _f[0], setSliderContainer = _f[1];
    var _g = useState(null), innerSlider = _g[0], setInnerSlider = _g[1];
    var _h = useState(null), containerElement = _h[0], setContainerElement = _h[1];
    var calculateCenterIndex = function () {
        return Math.ceil((slides.elementPerView || 1) / 2) - 1;
    };
    var calculateAmountOfPage = function () {
        var childrenLength = Array.isArray(children) ? Object.values(children).length : 1;
        if (slides.elementPerView && pagination.elementPerPage && children)
            return Math.ceil((childrenLength - pagination.elementPerPage) / pagination.elementPerPage) + 1;
        return 0;
    };
    var _j = useState(0), paginationIndex = _j[0], setPaginationIndex = _j[1];
    var _k = useState(calculateAmountOfPage()), paginationAmount = _k[0], setPaginationAmount = _k[1];
    var _l = useState(false), paginationDisable = _l[0], setPaginationDisable = _l[1];
    // page additional start & end list slides
    // if not enough page to add, extra = 0
    var getExtraPage = function () {
        if (pagination.extraPage) {
            if (paginationAmount < 2 && paginationAmount <= pagination.extraPage) {
                return 0;
            }
            else {
                return pagination.extraPage;
            }
        }
        return 0;
    };
    var getWidthSlideElement = function () {
        if (sliderContainer) {
            var container_1 = sliderContainer.getBoundingClientRect();
            var elementPerView = slides.elementPerView || 0;
            var spaceBetween = slides.spaceBetween || 0;
            return container_1.width / elementPerView - (spaceBetween * (elementPerView - 1)) / elementPerView;
        }
        return 0;
    };
    var isTouchDevice = function () {
        return !!('ontouchstart' in window);
    };
    var smoothTransition = function (position) {
        if (innerSlider) {
            innerSlider.style.transform = "translateX(-".concat(position, "px)");
            innerSlider.style.transition = "".concat(transitionTime, "ms");
            setTimeout(function () { return (innerSlider.style.transition = '0s'); }, transitionTime);
        }
    };
    var handlePaginationChange = function (idx) {
        if (innerSlider && sliderContainer) {
            setPaginationDisable(true);
            var spaceBetween = slides.spaceBetween || 0;
            var elementPerPage = pagination.elementPerPage || 0;
            var widthEachPage_1 = (getWidthSlideElement() + spaceBetween) * elementPerPage;
            smoothTransition((idx + getExtraPage()) * widthEachPage_1);
            if (idx < 0) {
                setTimeout(function () {
                    innerSlider.style.transform = "translateX(-".concat((paginationAmount + getExtraPage() - 1) * widthEachPage_1, "px)");
                }, transitionTime);
                setPaginationIndex(paginationAmount - 1);
                setTimeout(function () { return setPaginationDisable(false); }, transitionTime);
                return;
            }
            if (idx >= paginationAmount) {
                setTimeout(function () {
                    innerSlider.style.transform = "translateX(-".concat(getExtraPage() * widthEachPage_1, "px)");
                }, transitionTime);
                setPaginationIndex(0);
                setTimeout(function () { return setPaginationDisable(false); }, transitionTime);
                return;
            }
            setTimeout(function () { return setPaginationDisable(false); }, transitionTime);
            setPaginationIndex(idx);
        }
    };
    // add grab and move slide event
    useEffect(function () {
        if (sliderContainer && innerSlider && paginationAmount) {
            var body_1 = document.querySelector('body');
            var scrollStatus_1 = ''; // detect mouse move is horizontal or vertical
            var pressed_1 = false; // mouse down or not?
            var startX_1; // position X when mouse down
            var x_1; // position X when mouse move
            var downX_1; // screen X when mouse down
            var downY_1; // screen Y when mouse down
            var upX_1; // screen X when mouse up
            // position transform of InnerSlider
            var getInnerPosition_1 = function () {
                var position = innerSlider.style.transform.match(/[-.\d]/g);
                if (position)
                    return Number(position.join(''));
                else
                    return 0;
            };
            // move <Slides> back to position of nearest element
            var checkBoundary_1 = function () {
                var outer = sliderContainer.getBoundingClientRect();
                var inner = innerSlider.getBoundingClientRect();
                var position = getInnerPosition_1();
                var spaceBetween = slides.spaceBetween || 0;
                var elementPerPage = pagination.elementPerPage || 0;
                // width on a page, a page can have so many slide
                var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                // handle grab slides move out container on left side
                if (position > 0) {
                    // because if only 1 item, next index will be 0
                    var index_1 = paginationAmount === 1 ? 0 : paginationAmount;
                    smoothTransition(0);
                    setTimeout(function () {
                        innerSlider.style.transform = "translateX(-".concat(index_1 * widthEachPage, "px)");
                    }, transitionTime);
                    setPaginationIndex(index_1 - getExtraPage());
                    return;
                }
                // handle grab slides move out container on right side
                if (inner.right < outer.right) {
                    var index_2 = getExtraPage();
                    smoothTransition(inner.width - outer.width);
                    setTimeout(function () {
                        innerSlider.style.transform = "translateX(-".concat(index_2 * widthEachPage, "px)");
                    }, transitionTime);
                    setPaginationIndex(index_2 - getExtraPage());
                    return;
                }
                // handle grab slides move in container
                if (position <= 0) {
                    // if move to left downX < upX will rounding 0.85 -> 0 & 0.86 -> 1, make grab move smooth
                    var indexPage = Math.abs(fixedNumber(position / widthEachPage, downX_1 < upX_1 ? 1 - transitionSensitivity : transitionSensitivity));
                    smoothTransition(indexPage * widthEachPage);
                    // order page: 0 1 2 3 4 5 6 7 - 0 1 6 7 is additional page - 2 3 4 5 is real page
                    // if indexPage is addtional page, transform it to real page
                    // indexPage = 0 => index = 4 | indexPage = 6 => index = 2
                    if (indexPage < getExtraPage()) {
                        var index_3 = paginationAmount + indexPage;
                        setTimeout(function () {
                            innerSlider.style.transform = "translateX(-".concat(index_3 * widthEachPage, "px)");
                        }, transitionTime);
                        setPaginationIndex(index_3 - getExtraPage());
                        return;
                    }
                    if (indexPage >= getExtraPage() + paginationAmount) {
                        var index_4 = indexPage - paginationAmount;
                        setTimeout(function () {
                            innerSlider.style.transform = "translateX(-".concat(index_4 * widthEachPage, "px)");
                        }, transitionTime);
                        setPaginationIndex(index_4 - getExtraPage());
                        return;
                    }
                    setPaginationIndex(indexPage - getExtraPage());
                }
            };
            if (!isTouchDevice()) {
                // Desktop device event
                sliderContainer.addEventListener('mousedown', function (e) {
                    pressed_1 = true;
                    startX_1 = e.clientX - getInnerPosition_1();
                    downX_1 = e.clientX;
                    if (body_1)
                        body_1.style.cursor = 'grabbing';
                });
                window.addEventListener('mousemove', function (e) {
                    if (!pressed_1)
                        return;
                    e.preventDefault();
                    x_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'none'; // prevent click child after mouse up
                    innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                });
                window.addEventListener('mouseup', function (e) {
                    if (!pressed_1)
                        return;
                    if (body_1)
                        body_1.style.cursor = 'default';
                    pressed_1 = false;
                    upX_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'auto';
                    checkBoundary_1();
                });
            }
            else {
                // Mobile device event
                sliderContainer.addEventListener('touchstart', function (e) {
                    pressed_1 = true;
                    downX_1 = e.changedTouches[0].pageX;
                    downY_1 = e.changedTouches[0].pageY;
                    startX_1 = e.changedTouches[0].pageX - getInnerPosition_1();
                });
                sliderContainer.addEventListener('touchmove', function (e) {
                    if (!pressed_1)
                        return;
                    // find out touch move is vertical or horizontal, do nothing if scrollStatus !== 'horizontal'
                    if (scrollStatus_1 === '' && Math.abs(downY_1 - e.changedTouches[0].pageY) > 10) {
                        scrollStatus_1 = 'vertical';
                        return;
                    }
                    if (scrollStatus_1 === '' && Math.abs(downX_1 - e.changedTouches[0].pageX) > 10) {
                        scrollStatus_1 = 'horizontal';
                        return;
                    }
                    if (scrollStatus_1 === 'horizontal') {
                        e.preventDefault();
                        x_1 = e.changedTouches[0].pageX;
                        innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                    }
                });
                sliderContainer.addEventListener('touchend', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
                sliderContainer.addEventListener('touchcancel', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
            }
        }
    }, [innerSlider, sliderContainer, paginationAmount]);
    // handle automation transform slide event
    useEffect(function () {
        if (autoEnable && containerElement && innerSlider && paginationAmount && getExtraPage() > 0) {
            var interval_1 = null;
            var startInterval_1 = function () {
                var elements = containerElement.querySelectorAll("[data-id^=".concat(id, "-pagination]"));
                var max = paginationAmount;
                var index = paginationIndex;
                elements.forEach(function (e, idx) {
                    var _a;
                    if ((_a = e.getAttribute('data-id')) === null || _a === void 0 ? void 0 : _a.includes('true'))
                        index = idx;
                });
                interval_1 = setInterval(function () {
                    var spaceBetween = slides.spaceBetween || 0;
                    var elementPerPage = pagination.elementPerPage || 0;
                    if (index === max - 1) {
                        var widthEachPage_2 = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                        var idx_1 = getExtraPage();
                        smoothTransition((paginationAmount + getExtraPage()) * widthEachPage_2);
                        setTimeout(function () {
                            innerSlider.style.transform = "translateX(-".concat(idx_1 * widthEachPage_2, "px)");
                        }, transitionTime);
                        setPaginationIndex(0);
                        index = 0;
                    }
                    else {
                        handlePaginationChange(index + 1);
                        index++;
                    }
                }, autoTime);
            };
            var stopInterval_1 = function () {
                clearInterval(interval_1);
                interval_1 = null;
            };
            startInterval_1();
            if (isTouchDevice()) {
                containerElement.addEventListener('touchstart', function () { return setTimeout(stopInterval_1, 200); });
                containerElement.addEventListener('touchend', function () { return setTimeout(startInterval_1, 200); });
            }
            else {
                containerElement.addEventListener('mouseover', stopInterval_1);
                containerElement.addEventListener('mouseout', startInterval_1);
            }
        }
    }, [autoEnable, containerElement, innerSlider, paginationAmount]);
    useDidUpdateEffect(function () {
        if (children && slides.elementPerView)
            setPaginationAmount(calculateAmountOfPage());
    }, [children, slides.elementPerView]);
    useDidUpdateEffect(function () {
        pagination.onPageChange && pagination.onPageChange(paginationIndex);
    }, [paginationIndex]);
    // transform to position of start page at begin slideshow
    useEffect(function () {
        if (innerSlider && children) {
            var spaceBetween = slides.spaceBetween || 0;
            var elementPerPage = pagination.elementPerPage || 0;
            var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
            innerSlider.style.transform = "translateX(-".concat((getExtraPage() + (pagination.defaultPage || 0)) * widthEachPage, "px)");
            setPaginationIndex(pagination.defaultPage || 0);
        }
    }, [innerSlider, children]);
    return !isRobot ? (React__default.createElement(Container, { id: id, style: container.style, ref: setContainerElement, className: className },
        React__default.createElement(SliderContainer, { style: slides.style, ref: setSliderContainer },
            React__default.createElement("div", { style: {
                    transform: "translateX(".concat((getWidthSlideElement() + (slides.spaceBetween || 0)) * calculateCenterIndex(), "px)")
                } },
                React__default.createElement(Slides, { innerRef: setInnerSlider, spaceBetween: slides.spaceBetween, elementPerView: slides.elementPerView, widthElement: getWidthSlideElement(), loading: loadingEnable, loadingHeight: loadingHeight, extraElement: getExtraPage(), activeItem: paginationIndex, activeClassName: pagination.activeClassName }, children))),
        pagination.type !== 'none' && (React__default.createElement(Pagination, { type: pagination.type, position: pagination.position, style: pagination.style, isLoading: loadingEnable, id: "".concat(id, "-pagination"), onItemClick: function (idx) { return handlePaginationChange(idx); }, activeItem: paginationIndex, amountItem: paginationAmount, maxItem: (pagination.maxShow || 0) > paginationAmount ? paginationAmount : pagination.maxShow, styleString: pagination.styleString, customNavigation: pagination.navigation, isDisable: paginationDisable, isLoop: true })))) : (React__default.createElement(React__default.Fragment, null, children));
};

export { Slider as default };
//# sourceMappingURL=index.js.map
